import { render } from "./statblock.vue?vue&type=template&id=3c7bcf16"
import script from "./statblock.vue?vue&type=script&lang=js"
export * from "./statblock.vue?vue&type=script&lang=js"

import "./statblock.vue?vue&type=style&index=0&id=3c7bcf16&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__